<template>
  <el-dialog
    title="查看商品"
    :visible.sync="visible"
    width="720px"
    append-to-body
    class="goods-view-dialog"
    @close="handleClose"
  >
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      stripe
      class="goods-view-dialog__table"
    >
      <el-table-column prop="item_name" label="商品名称" min-width="200" />
      <el-table-column prop="goods_id" label="商品ID" width="100" />
      <el-table-column prop="sku_code" label="SKU编码" min-width="140" />
    </el-table>

    <div class="goods-view-dialog__pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size.sync="pagination.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pagination.total"
        @size-change="handlePageChange"
        @current-change="handlePageChange"
      />
    </div>

    <div slot="footer">
      <el-button type="primary" @click="handleClose">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getActivitySkus } from '../api'

export default {
  name: 'GoodsViewDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activity: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.resetDialog()
      }
    }
  },
  methods: {
    mapSkuRow (item) {
      return {
        ...item,
        item_name: item.item_name_snapshot || item.item_name || '',
        goods_id: item.goods_id || item.item_id || ''
      }
    },
    buildQueryParams () {
      return {
        page: String(this.pagination.page),
        pageSize: String(this.pagination.pageSize)
      }
    },
    resetDialog () {
      this.pagination.page = 1
      this.pagination.pageSize = 20
      this.loadTableData()
    },
    async loadTableData () {
      const activityId = this.activity && this.activity.activity_id
      if (!activityId) {
        this.tableData = []
        this.pagination.total = 0
        return
      }
      this.loading = true
      try {
        const res = await getActivitySkus(activityId, this.buildQueryParams())
        const data = res.data.data || {}
        const list = data.list || []
        this.tableData = list.map(item => this.mapSkuRow(item))
        this.pagination.total = data.total_count || 0
      } catch (e) {
        const msg = (e.response && e.response.data && e.response.data.message) || e.message || '获取商品列表失败'
        this.$message.error(msg)
        this.tableData = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    handlePageChange () {
      this.loadTableData()
    },
    handleClose () {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.goods-view-dialog {
  &__table {
    width: 100%;
  }

  &__pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
}
</style>
